import { UseQueryOptions } from '@tanstack/react-query';

import { ApplicationAccessType } from 'domains/content/types';
import { CuredApiPaths } from 'models/enums';

import useQuery from '../useQuery';

import QueryKeys from './keys';

const useApplicationsAccessList = (reactQueryOptions?: UseQueryOptions<ApplicationAccessType[], Error>) =>
    useQuery(QueryKeys.APPLICATIONS_ACCESS_LIST, CuredApiPaths.APPLCIATIONS_ACCESS_LIST, reactQueryOptions);

export default useApplicationsAccessList;
